// Greek — scripts/translate-locale.mjs 로 생성 (en.js 기준).
// 손으로 고친 값은 다음 실행에서 덮이지 않는다 (--force 제외).
// 자리표시자({n} 등)가 어긋난 항목은 영어를 그대로 둔다.
export const el = {
  "uploadTitle": "Ανέβασε φωτογραφίες",
  "uploadHint": "Κάνε κλικ ή σύρε εικόνες εδώ",
  "uploadHintTouch": "Πάτα για επιλογή φωτογραφιών",
  "uploadOr": "ή",
  "takePhoto": "Βγάλε φωτογραφία",
  "yourPhotos": "Οι φωτογραφίες σου",
  "photoLabel": "Φωτογραφία {n}",
  "photoCount": "{n} φωτογραφίες",
  "addPhoto": "Πρόσθεσε φωτογραφία",
  "continue": "Συνέχεια",
  "stepLabel": "Βήμα {current} από {total}",
  "chooseStyle": "Διάλεξε στυλ σχεδίασης",
  "describeCustomStyle": "Περίγραψε το δικό σου στυλ",
  "uploadReferenceTitle": "Ανέβασε φωτογραφία αναφοράς",
  "uploadReferenceHint": "Η AI θα πάρει τους τόνους, τα υλικά και τη διάθεσή της — η φωτογραφία του δωματίου σου μένει ίδια.",
  "removeReference": "Αφαίρεση αναφοράς",
  "cleanupOptionTidy": "Τακτοποίηση",
  "cleanupOptionTidyDesc": "Κράτα τα έπιπλα, αφαίρεσε ακαταστασία / σκουπίδια / πιάτα",
  "cleanupOptionEmpty": "Άδειασμα δωματίου",
  "cleanupOptionEmptyDesc": "Αφαίρεσε όλα τα έπιπλα και τη διακόσμηση. Τοίχοι και δάπεδο παραμένουν",
  "cleanupChooseOption": "Διάλεξε τρόπο καθαρισμού",
  "layoutOptionFlow": "Καλύτερη ροή",
  "layoutOptionFlowDesc": "Βελτίωσε τις διαδρομές και την πρόσβαση — κινείσαι πιο άνετα",
  "layoutOptionSpacious": "Πιο ευρύχωρο",
  "layoutOptionSpaciousDesc": "Άνοιξε τις οπτικές φυγές και μείωσε την ακαταστασία — μοιάζει μεγαλύτερο",
  "planChooseOption": "Τι να δημιουργήσουμε από την κάτοψή σου;",
  "planOption_3d": "3D κάτοψη",
  "planOption_3dDesc": "Όλο το σπίτι από ψηλά, επιπλωμένο σε ένα στυλ",
  "planOption_room": "Ένα δωμάτιο",
  "planOption_roomDesc": "Χρωμάτισε ένα δωμάτιο στην κάτοψη και δες το στο ύψος των ματιών",
  "planOption_clean": "Καθαρό σχέδιο κάτοψης",
  "planOption_cleanDesc": "Ένα σχέδιο ή θολή κάτοψη, ξανασχεδιασμένη καθαρά",
  "planCleanKindTitle": "Τύπος σχεδίου",
  "planCleanKind_line": "Ασπρόμαυρο",
  "planCleanKind_color": "Έγχρωμη κάτοψη",
  "planStyleTitle": "Στυλ",
  "planRoomTitle": "Ποιο δωμάτιο;",
  "planRoomSignIn": "Συνδέσου για να διαλέξεις δωμάτιο στην κάτοψη.",
  "planRoomPaint": "Χρωμάτισε το δωμάτιο στην κάτοψη",
  "planRoomPicked": "Το δωμάτιο επιλέχθηκε",
  "planRoomRepaint": "Χρωμάτισε ξανά",
  "planRoomClear": "Καθαρισμός",
  "planRoomNamePlaceholder": "Ή γράψε το όνομα του δωματίου (π.χ. κύρια κρεβατοκάμαρα)",
  "planCropHint": "Περίκοψε τη φωτογραφία μόνο στην κάτοψη για πιο ακριβές αποτέλεσμα.",
  "planFirstOnly": "Μόνο η πρώτη φωτογραφία χρησιμοποιείται ως κάτοψη.",
  "planRoomPickTitle": "Διάλεξε δωμάτιο",
  "planRoomPickHint": "Χρωμάτισε το δωμάτιο που θέλεις να δεις. Ένα πρόχειρο γέμισμα αρκεί.",
  "planRoomPickDone": "Χρήση αυτού του δωματίου",
  "planRoomNeedPick": "Χρωμάτισε ένα δωμάτιο στην κάτοψη ή γράψε το όνομά του.",
  "errNotFloorplan": "Αυτό δεν μοιάζει με κάτοψη. Ανέβασε μια κάτοψη ή διάλεξε ένα στυλ.",
  "planRoomFrom": "Επιλεγμένο δωμάτιο στην κάτοψη",
  "planInputLabel": "Κάτοψη",
  "planOutput_plan_3d": "3D κάτοψη",
  "planOutput_plan_room": "Προβολή δωματίου",
  "planOutput_plan_clean": "Καθαρή κάτοψη",
  "planOutput_plan_color": "Έγχρωμη κάτοψη",
  "planRoomFromResult": "Δες ένα δωμάτιο",
  "planRoomMake": "Φτιάξε αυτό το δωμάτιο",
  "planRoomMeta": "{n} πιστώσεις · αυτό το δωμάτιο στο ύψος των ματιών, ίδιο σπίτι",
  "layoutChooseOption": "Διάλεξε τρόπο αναδιάταξης",
  "creditEarnHint": "Κέρδισε πιστώσεις με καθημερινή σύνδεση (+1) ή προσκαλώντας φίλους (+5 για κάθε φίλο).",
  "languageHint": "Χρησιμοποιείται και για την ανάλυση σχεδιασμού.",
  "reuseStyle": "— Επαναχρησιμοποίηση προηγούμενου στυλ —",
  "customPlaceholder": "Περίγραψε το στυλ που θέλεις (π.χ. 'ζεστό καταφύγιο με ξύλο', 'μελλοντικός μινιμαλισμός με μεταλλικές λεπτομέρειες')",
  "customStylePublicHint": "Το προσαρμοσμένο κείμενο στυλ μπορεί να εμφανιστεί ανώνυμα στην κοινότητα. Μπορείς να το απενεργοποιήσεις στις Ρυθμίσεις λογαριασμού.",
  "communityRankTitle": "Δημοφιλή στυλ",
  "communityPeople": "Χρήστες: {n}",
  "customStylesChip": "Προσαρμοσμένα στυλ",
  "galleryRecentBadge": "Μόλις τώρα",
  "timeJustNow": "μόλις τώρα",
  "timeAgoMin": "πριν {n}λ",
  "timeAgoHour": "πριν {n}ω",
  "communityViewAll": "Προβολή όλων",
  "galleryTitle": "Δημοφιλή στυλ",
  "briefsLabel": "Νέα",
  "briefTopupKicker": "Πιστώσεις",
  "briefTopupTitle": "Δεν έχεις αρκετές πιστώσεις για το επόμενο σχέδιο",
  "briefTopupLine": "Τα δωρεάν credits ανανεώνονται αύριο. Χρειάζεσαι περισσότερα τώρα; Πάρε ένα πακέτο.",
  "briefSeasonKicker": "Εποχιακό",
  "briefSeasonTitle": "Το {name} είναι εδώ",
  "briefSeasonLine": "Ένα εποχιακό στιλ — διαθέσιμο μόνο για λίγες εβδομάδες.",
  "briefInviteKicker": "Πρόσκληση",
  "briefInviteTitle": "Προσκάλεσε έναν φίλο — παίρνετε και οι δύο +{n} πιστώσεις",
  "briefInviteLine": "Μοιράσου τον σύνδεσμό σου. Οι πιστώσεις προστίθενται μόλις εγγραφεί.",
  "galleryEmpty": "Δεν υπάρχει κάτι δημοφιλές ακόμα — τα στυλ εμφανίζονται μόλις αρχίσουν να χρησιμοποιούνται.",
  "galleryBuiltinTitle": "Τα πιο δημοφιλή στυλ τώρα",
  "galleryPopularCustom": "Δημοφιλή προσαρμοσμένα στυλ",
  "galleryDiscoverTitle": "Ανακάλυψε προσαρμοσμένα στυλ",
  "galleryShuffle": "Τυχαία σειρά",
  "galleryTranslate": "Μετάφραση",
  "galleryTranslating": "Μετάφραση…",
  "galleryOriginal": "Προβολή αρχικού",
  "galleryLiveTab": "Live",
  "galleryLiveWaiting": "Αναμονή για νέα στυλ…",
  "galleryLiveTitle": "Χρησιμοποιείται αυτή τη στιγμή",
  "galleryRecentCustom": "Πρόσφατα προσαρμοσμένα στυλ",
  "galleryUse": "Χρήση αυτού του στυλ",
  "styleShareNotice": "Το προσαρμοσμένο κείμενο στυλ μπορεί να εμφανιστεί ανώνυμα στην κοινότητα.",
  "styleShareNoticeSettings": "Απενεργοποίηση στις ρυθμίσεις",
  "styleShareNoticeOk": "Εντάξει",
  "communityTopTitle": "Δημοφιλή προσαρμοσμένα στυλ",
  "communityRecentTitle": "Μόλις χρησιμοποιήθηκαν από άλλους",
  "communityUses": "{n}× χρήσεις",
  "communityDesigns": "{n} σχέδια",
  "communityDesignsOne": "{n} σχέδιο",
  "styleShareTitle": "Κοινοποίηση προσαρμοσμένων στυλ",
  "styleShareDesc": "Επίτρεψε σε άλλους να ανακαλύψουν και να δοκιμάσουν τα στυλ που γράφεις. Οι φωτογραφίες σου δεν κοινοποιούνται ποτέ.",
  "additionalRequests": "Επιπλέον αιτήματα",
  "optional": "(προαιρετικό)",
  "additionalPlaceholder": "Επιπλέον λεπτομέρειες για το σχέδιο {style}; (π.χ. 'πρόσθεσε ξύλινο τραπεζάκι', 'χρησιμοποίησε πετρόλ ως χρώμα έμφασης')",
  "addAdditionalRequest": "+ Προσθήκη ειδικών αιτημάτων",
  "generateDesign": "Δημιουργία σχεδίου",
  "back": "Πίσω",
  "generatingOne": "Η AI σχεδιάζει τον χώρο σου…",
  "generatingMany": "Η AI δημιουργεί {n} σχέδια στο ίδιο ύφος για το δωμάτιό σου…",
  "generatingOneExterior": "Η AI ανασχεδιάζει την πρόσοψή σου…",
  "generatingManyExterior": "Η AI δημιουργεί {n} εικόνες της πρόσοψης στο ίδιο ύφος…",
  "generatingOneGarden": "Η AI ανασχεδιάζει τον κήπο σου…",
  "generatingManyGarden": "Η AI δημιουργεί {n} εικόνες του κήπου στο ίδιο ύφος…",
  "generationFailed": "Η δημιουργία απέτυχε",
  "tryAgain": "Δοκίμασε ξανά",
  "errNoInternet": "Χωρίς σύνδεση στο διαδίκτυο. Έλεγξε το δίκτυό σου και δοκίμασε ξανά.",
  "errTimeout": "Η AI άργησε να απαντήσει. Δοκίμασε ξανά.",
  "errTooMany": "Πολλά αιτήματα. Περίμενε λίγο και δοκίμασε ξανά.",
  "errNetwork": "Σφάλμα δικτύου. Έλεγξε τη σύνδεσή σου και δοκίμασε ξανά.",
  "errAI": "Παρουσιάστηκε πρόβλημα στην υπηρεσία AI. Δοκίμασε ξανά.",
  "errFileType": "Μη υποστηριζόμενος τύπος αρχείου. Ανέβασε εικόνα JPEG, PNG ή WebP.",
  "errFileTooLarge": "Το αρχείο είναι πολύ μεγάλο. Ανέβασε εικόνα κάτω των 20MB.",
  "errPhotoRead": "Δεν ήταν δυνατή η ανάγνωση της φωτογραφίας. Δοκίμασε άλλη.",
  "errCameraAccess": "Δεν υπάρχει πρόσβαση στην κάμερα. Επίτρεψε την πρόσβαση στις Ρυθμίσεις.",
  "errCameraCapture": "Δεν ήταν δυνατή η λήψη φωτογραφίας. Δοκίμασε ξανά.",
  "errCaptionSave": "Δεν ήταν δυνατή η αποθήκευση της λεζάντας. Δοκίμασε ξανά.",
  "imageUnavailable": "Η εικόνα δεν είναι διαθέσιμη",
  "designShareText": "Δες αυτό το σχέδιο {style} από το archelier",
  "altPhoto": "Φωτογραφία {n}",
  "altOriginal": "Αρχική {n}",
  "altGenerated": "Σχέδιο {n}",
  "errInvalidSpace": "Δεν μπορέσαμε να αναγνωρίσουμε τον χώρο. Χρησιμοποίησε μια φωτογραφία που δείχνει ένα δωμάτιο — τοίχο και δάπεδο μαζί, ή μια γωνία.",
  "pickAnotherPhoto": "Διάλεξε άλλη φωτογραφία",
  "errCustomStyle": "Περίγραψε το προσαρμοσμένο στυλ σου.",
  "errSignIn": "Η σύνδεση απέτυχε. Δοκίμασε ξανά.",
  "errInsufficientCredits": "Ξέμεινες από πιστώσεις. Έλα ξανά αύριο για το καθημερινό σου μπόνους.",
  "creditCostHint": "{n} φωτογραφίες χρησιμοποιούν {c} πιστώσεις — {p} ανά φωτογραφία.",
  "errCreditsShort": "Χρειάζονται {need} πιστώσεις και έχεις {have}. Αφαίρεσε μια φωτογραφία ή προσκάλεσε έναν φίλο.",
  "credits": "Πιστώσεις",
  "creditsOne": "{n} πίστωση",
  "creditsMany": "{n} πιστώσεις",
  "outOfCredits": "Ξέμεινες από πιστώσεις",
  "creditModalTitle": "Απόκτησε περισσότερες πιστώσεις",
  "creditModalDesc": "Οι καθημερινές σου πιστώσεις ανανεώνονται αύριο. Θέλεις κι άλλες τώρα;",
  "creditModalWallDesc": "Αυτά ήταν τα σημερινά δωρεάν σχέδια. {n} ακόμα έρχονται αύριο — ή κάνε ανανέωση τώρα και συνέχισε.",
  "errOutOfCreditsToday": "Ξέμεινες από πιστώσεις για σήμερα. {n} δωρεάν σχέδια έρχονται αύριο — ή κάνε ανανέωση για να συνεχίσεις.",
  "lastFreeHint": "Αυτό ήταν το τελευταίο σημερινό δωρεάν σχέδιο. {n} ακόμα αύριο.",
  "lastFreeHintCta": "Κάνε ανανέωση τώρα",
  "creditModalChatFree": "Η συνομιλία με τον Gio, τον σχεδιαστή σου, παραμένει δωρεάν.",
  "creditModalGuestTitle": "Συνδέσου για να συνεχίσεις να δημιουργείς",
  "creditModalGuestDesc": "Με τη σύνδεση παίρνεις δωρεάν πιστώσεις κάθε μέρα, συν αποθήκευση και κοινοποίηση.",
  "creditOptionSignIn": "Σύνδεση και συνέχεια",
  "creditOptionSignInDesc": "Ξεκίνα σε ένα δευτερόλεπτο με Google ή Apple",
  "creditOptionInvite": "Προσκάλεσε έναν φίλο",
  "creditOptionInviteDesc": "Παίρνετε και οι δύο +{n} πιστώσεις μόλις γραφτεί ο φίλος σου",
  "comingSoon": "Σύντομα διαθέσιμο",
  "close": "Κλείσιμο",
  "getAppTitle": "archelier",
  "getAppDesc": "Ανασχεδίασε τον χώρο σου στην εφαρμογή",
  "getAppCta": "Λήψη",
  "appGateTitle": "Συνέχεια στην εφαρμογή",
  "appGateDesc": "Ο σχεδιασμός γίνεται καλύτερα στην εφαρμογή — κάμερα, αποθηκευμένα σχέδια και ταχύτερα αποτελέσματα.",
  "appGateCta": "Απόκτησε την εφαρμογή",
  "appGateNotNow": "Όχι τώρα",
  "dailyBonusHint": "Παίρνεις {n} δωρεάν πιστώσεις κάθε μέρα.",
  "creditsAria": "Υπόλοιπο: {n}",
  "accountCreditsTitle": "Πιστώσεις",
  "creditsDailyLabel": "Ημερήσιες, ανανεώνονται τα μεσάνυχτα",
  "creditsBonusLabel": "Μπόνους, δεν λήγουν ποτέ",
  "creditsResetHint": "Παίρνεις {n} δωρεάν πιστώσεις κάθε μέρα. Οι πιστώσεις μπόνους από προσκλήσεις μένουν μέχρι να τις χρησιμοποιήσεις.",
  "creditsInviteCta": "Προσκάλεσε έναν φίλο για +{n}",
  "creditsTopUpCta": "Αγορά πιστώσεων",
  "inviteMenu": "Πρόσκληση φίλων",
  "profileShare": "Κοινοποίηση",
  "profileShareText": "Δες τα σχέδια του/της {name} στο archelier.",
  "original": "Αρχικό",
  "aiDesign": "Σχέδιο AI",
  "imageGenFailed": "Η δημιουργία εικόνας απέτυχε για αυτή τη φωτογραφία",
  "seeAnalysis": "Δες την ανάλυση σχεδιασμού παρακάτω.",
  "analysisTitle": "Ανάλυση εσωτερικής διακόσμησης",
  "spaceAnalysis": "Ανάλυση χώρου",
  "styleDescription": "Περιγραφή στυλ",
  "colorPalette": "Παλέτα χρωμάτων",
  "furnitureRec": "Προτάσεις επίπλων",
  "shopFor": "Βρες: {item}",
  "shopShort": "Αγορά",
  "paintMatch": "Πλησιέστερο χρώμα",
  "paintCodeCopy": "Αντιγραφή κωδικού χρώματος",
  "paintCodeCopied": "Ο κωδικός αντιγράφηκε",
  "editRegion": "Επεξεργασία περιοχής",
  "editRegionTitle": "Επεξεργασία σχεδίου",
  "editRegionDesc": "Πες στην AI τι να αλλάξει και τι να βάλει στη θέση του. Το υπόλοιπο δωμάτιο μένει ίδιο.",
  "editRegionBrushHint": "Πες στην AI τι να αλλάξει ή να προσθέσει. Για αλλαγή σε ένα σημείο, πέρασέ το πρώτα με το πινέλο — αλλιώς αλλάζει όλη η εικόνα. Για αφαίρεση, πέρασέ το με το πινέλο και γράψε «αφαίρεσέ το».",
  "editRegionMeta": "Αποθηκεύτηκε ως νέο σχέδιο · {n} πιστώσεις",
  "editedFromBanner": "Αυτό είναι ένα επεξεργασμένο αντίγραφο.",
  "viewOriginal": "Προβολή αρχικού",
  "editsOfThisDesign": "Επεξεργασίες αυτού του σχεδίου",
  "editsOfThisDesignDesc": "Σχέδια που έφτιαξες αλλάζοντας σημεία αυτού του σχεδίου.",
  "chatTitle": "Σύμβουλος σχεδίασης AI",
  "chatHint": "Κάνε επιπλέον ερωτήσεις για αυτό το δωμάτιο. Η AI βλέπει το σχέδιό σου και βασίζεται σε αυτό.",
  "chatStart": "Έναρξη συνομιλίας",
  "chatPlaceholder": "Ρώτα για ένα έπιπλο, χρώμα ή ιδέα διάταξης…",
  "chatSend": "Αποστολή",
  "chatSending": "Σκέφτεται…",
  "chatSuggestion1": "Ποιο φωτιστικό θα έκανε πιο ζεστό το δωμάτιο;",
  "chatSuggestion2": "Πώς μπορώ να το κάνω να φαίνεται πιο ευρύχωρο;",
  "chatSuggestion3": "Ποια 3 πράγματα πρέπει να αλλάξω πρώτα;",
  "chatTurnsRemaining": "Μηνύματα που απομένουν: {n}",
  "chatTurnsExhausted": "Έφτασες το όριο συνομιλίας για αυτό το σχέδιο. Ξεκίνησε νέο σχέδιο για να συνεχίσεις.",
  "chatErrGeneric": "Ο σύμβουλος δεν μπόρεσε να απαντήσει. Δοκίμασε ξανά.",
  "chatPro": "Pro — απεριόριστη συνομιλία",
  "chatRetry": "Δοκίμασε ξανά",
  "commentsTitle": "Σχόλια",
  "commentPlaceholder": "Πρόσθεσε ένα σχόλιο",
  "commentPost": "Δημοσίευση",
  "commentPosting": "Δημοσίευση…",
  "commentSignInHint": "Συνδέσου για να αφήσεις σχόλιο.",
  "commentEmpty": "Δεν υπάρχουν σχόλια ακόμη.",
  "commentDelete": "Διαγραφή",
  "commentDeleteConfirm": "Διαγραφή αυτού του σχολίου;",
  "commentTooLong": "Τα σχόλια περιορίζονται στους 500 χαρακτήρες.",
  "commentErrGeneric": "Αποτυχία δημοσίευσης σχολίου. Δοκίμασε ξανά.",
  "commentCount": "{n}",
  "bookmarksTitle": "Οι συλλογές μου",
  "tabDesigns": "Σχέδια",
  "tabCollections": "Συλλογές",
  "bookmarksSectionTitle": "Αποθηκευμένα σχέδια",
  "bookmarksEmpty": "Δεν υπάρχουν συλλογές ακόμη. Αποθήκευσε ένα σχέδιο για να ξεκινήσεις.",
  "bookmarksAdd": "Αποθήκευση",
  "bookmarksAdded": "Αποθηκεύτηκε",
  "bookmarksRemove": "Αφαίρεση από τα αποθηκευμένα",
  "bookmarksSignInHint": "Συνδέσου για να αποθηκεύσεις σχέδια.",
  "saved": "Αποθηκεύτηκε",
  "savedCollectionDefault": "Αποθηκευμένα",
  "follow": "Ακολούθηση",
  "unfollow": "Διακοπή ακολούθησης",
  "following": "Ακολουθείς",
  "followers": "Ακόλουθοι",
  "followingTab": "Ακολουθείς",
  "followingEmpty": "Ακολούθησε άτομα για να βλέπεις τα τελευταία σχέδιά τους εδώ.",
  "followersEmpty": "Δεν υπάρχουν ακόλουθοι ακόμη.",
  "followingEmpty2": "Δεν ακολουθείς κανέναν ακόμη.",
  "followSignInHint": "Συνδέσου για να ακολουθήσεις",
  "cannotFollowSelf": "Δεν μπορείς να ακολουθήσεις τον εαυτό σου.",
  "profile": "Προφίλ",
  "profileNotFound": "Αυτό το προφίλ δεν υπάρχει.",
  "profileDesigns": "Σχέδια",
  "profileDesignsCount": "Σχέδια",
  "profileFollowers": "Ακόλουθοι",
  "profileFollowing": "Ακολουθείς",
  "profileBio": "Βιογραφικό",
  "profileEdit": "Επεξεργασία προφίλ",
  "profileMyProfile": "Το προφίλ μου",
  "displayNameLabel": "Όνομα εμφάνισης",
  "displayNamePlaceholder": "Το όνομά σου ή το studio (προαιρετικό)",
  "displayNameSave": "Αποθήκευση ονόματος",
  "displayNameSaved": "Το όνομα αποθηκεύτηκε",
  "displayNameErrGeneric": "Δεν ήταν δυνατή η αποθήκευση του ονόματος. Δοκίμασε ξανά.",
  "handleLabel": "Όνομα χρήστη",
  "handlePlaceholder": "πεζά γράμματα, ψηφία, κάτω παύλα (3-20 χαρακτήρες)",
  "handleSave": "Αποθήκευση ονόματος χρήστη",
  "handleSaved": "Το όνομα χρήστη αποθηκεύτηκε",
  "handleInvalid": "Το όνομα χρήστη πρέπει να είναι 3-20 χαρακτήρες: a-z, 0-9, κάτω παύλα.",
  "handleTaken": "Αυτό το όνομα χρήστη χρησιμοποιείται ήδη.",
  "handleErrGeneric": "Δεν ήταν δυνατή η αποθήκευση του ονόματος χρήστη. Δοκίμασε ξανά.",
  "bioPlaceholder": "Γράψε λίγα λόγια για εσένα (έως 200 χαρακτήρες)",
  "bioSave": "Αποθήκευση βιογραφικού",
  "bioSaved": "Το βιογραφικό αποθηκεύτηκε",
  "bioErrGeneric": "Δεν ήταν δυνατή η αποθήκευση του βιογραφικού. Δοκίμασε ξανά.",
  "instagramLabel": "Instagram",
  "instagramPlaceholder": "username_instagram",
  "instagramInvalid": "Χρησιμοποίησε μόνο γράμματα, ψηφία, τελεία ή κάτω παύλα (έως 30).",
  "profileNoDesigns": "Δεν υπάρχουν σχέδια ακόμα.",
  "collections": "Συλλογές",
  "collectionsTab": "Συλλογές",
  "collectionMine": "Οι συλλογές μου",
  "collectionEmpty": "Δεν υπάρχουν συλλογές ακόμα.",
  "collectionPublicEmpty": "Δεν υπάρχουν δημόσιες συλλογές.",
  "collectionItemCount": "Σχέδια: {n}",
  "collectionEmpty2": "Αυτή η συλλογή είναι άδεια.",
  "newCollection": "Νέα συλλογή",
  "collectionNamePlaceholder": "Όνομα συλλογής (π.χ. Ιδέες για σαλόνι)",
  "collectionCreate": "Δημιουργία",
  "collectionDelete": "Διαγραφή συλλογής",
  "collectionDeleteConfirm": "Διαγραφή αυτής της συλλογής; Τα αντικείμενα θα αφαιρεθούν.",
  "collectionRename": "Μετονομασία συλλογής",
  "collectionVisibility": "Δημόσια συλλογή",
  "collectionVisibilityOn": "Οποιοσδήποτε έχει τον σύνδεσμο μπορεί να τη δει",
  "collectionVisibilityOff": "Μόνο εσύ μπορείς να δεις αυτή τη συλλογή",
  "addToCollection": "Προσθήκη σε συλλογή",
  "saveToCollection": "Αποθήκευση σε συλλογή",
  "collectionAdded": "Προστέθηκε",
  "collectionRemoveFromBoard": "Αφαίρεση από τη συλλογή",
  "collectionShareLink": "Αντιγραφή συνδέσμου συλλογής",
  "collectionByOwner": "από",
  "collectionNotFound": "Αυτή η συλλογή δεν υπάρχει ή είναι ιδιωτική.",
  "collectionErrCreate": "Δεν ήταν δυνατή η δημιουργία της συλλογής.",
  "collectionErrSave": "Δεν ήταν δυνατή η ενημέρωση της συλλογής.",
  "collectionDone": "Έτοιμο",
  "collectionPickerHint": "Πάτα σε μια συλλογή για να προσθέσεις ή να αφαιρέσεις αυτό το σχέδιο.",
  "uploadAcceptsHint": "Οι φωτογραφίες λειτουργούν καλύτερα, αλλά ταιριάζουν και σκίτσα, όψεις, κατόψεις και 3D στιγμιότυπα.",
  "examplePhotos": "Παραδείγματα φωτογραφιών",
  "detectedInputTypes": {
    "sketch": "Σκίτσο",
    "elevation": "Όψη",
    "floorplan": "Κάτοψη",
    "3d_model": "3D μοντέλο"
  },
  "floorplanDetectedBanner": "Μοιάζει με κάτοψη — δημιουργήθηκε απεικόνιση του μεγαλύτερου κοινού χώρου του σπιτιού (π.χ. σαλόνι) στο ύψος των ματιών. Για συγκεκριμένο δωμάτιο, πρόσθεσε μια σημείωση στο επόμενο αίτημά σου (π.χ. «απεικόνιση κύριας κρεβατοκάμαρας»).",
  "floorplanDetectedBannerWithRoom": "Μοιάζει με κάτοψη — δημιουργήθηκε απεικόνιση για το δωμάτιο {room} στο ύψος των ματιών. Για διαφορετικό δωμάτιο, πρόσθεσε μια σημείωση στο επόμενο αίτημά σου.",
  "spaceCategoryTitle": "Τι σχεδιάζεις;",
  "spaceCategories": {
    "interior": "Εσωτερικός χώρος",
    "exterior": "Εξωτερικό",
    "garden": "Κήπος"
  },
  "exteriorStyles": {
    "halloween": {
      "name": "Halloween",
      "description": "Σκαλιστές κολοκύθες, φανάρια, ατμοσφαιρική φθινοπωρινή βεράντα"
    },
    "christmas": {
      "name": "Χριστουγεννιάτικο",
      "description": "Στεφάνια, θερμά λαμπάκια, αειθαλείς γιρλάντες"
    },
    "lunar_new_year": {
      "name": "Σεληνιακή Πρωτοχρονιά",
      "description": "Κόκκινα φανάρια, χρυσές λεπτομέρειες, εορταστικές επιγραφές"
    },
    "spring_blossom": {
      "name": "Ανοιξιάτικη Άνθιση",
      "description": "Ανθισμένα δέντρα, παστέλ φυτά, δροσερό φως"
    },
    "modern_facade": {
      "name": "Μοντέρνα Πρόσοψη",
      "description": "Καθαρές γραμμές, μεγάλα τζάμια, συνδυασμός υλικών"
    },
    "modern_farmhouse": {
      "name": "Modern Farmhouse",
      "description": "Λευκή επένδυση, μαύρα πλαίσια, ξύλινες λεπτομέρειες"
    },
    "mediterranean": {
      "name": "Μεσογειακό",
      "description": "Σοβάς, τερακότα, τοξωτά ανοίγματα"
    },
    "craftsman": {
      "name": "Craftsman",
      "description": "Ξύλινες κεραμίδες, χαμηλά αετώματα, εμφανή δοκάρια"
    },
    "contemporary": {
      "name": "Σύγχρονο",
      "description": "Κοφτές γραμμές, έντονοι όγκοι, βιομηχανικά υλικά"
    },
    "minimalist_exterior": {
      "name": "Μινιμαλιστική Πρόσοψη",
      "description": "Λιτή παλέτα, εστίαση σε ένα υλικό"
    },
    "tudor": {
      "name": "Tudor",
      "description": "Αγγλικό Tudor — ξυλοδεσιές με απότομες στέγες"
    },
    "cape_cod": {
      "name": "Cape Cod",
      "description": "Παραδοσιακό Νέας Αγγλίας — λευκές επενδύσεις, μαύρα πατζούρια"
    },
    "japanese_traditional": {
      "name": "Παραδοσιακό Ιαπωνικό",
      "description": "Ξύλινος σκελετός Minka, κεραμοσκεπή και βεράντα engawa"
    },
    "mountain_cabin": {
      "name": "Ορεινό Καταφύγιο",
      "description": "Ξύλινο A-frame ή κορμοκαλύβα μέσα στη φύση"
    },
    "midcentury_exterior": {
      "name": "Mid-Century Πρόσοψη",
      "description": "Μοντερνισμός '50-'60 — επίπεδη στέγη, μεγάλα τζάμια, οριζόντιες γραμμές"
    }
  },
  "gardenStyles": {
    "halloween": {
      "name": "Halloween",
      "description": "Κολοκύθες, φανάρια, ομιχλώδης φθινοπωρινός κήπος"
    },
    "christmas": {
      "name": "Χριστουγεννιάτικο",
      "description": "Φωτισμένα αειθαλή, θερμά λαμπάκια, χειμερινός κήπος"
    },
    "lunar_new_year": {
      "name": "Σεληνιακή Πρωτοχρονιά",
      "description": "Κόκκινα φανάρια, ανθισμένα κλαδιά, εορταστικός κήπος"
    },
    "spring_blossom": {
      "name": "Ανοιξιάτικη Άνθιση",
      "description": "Ανθισμένες κερασιές, τουλίπες, φρέσκο ανοιξιάτικο πράσινο"
    },
    "modern": {
      "name": "Μοντέρνος Κήπος",
      "description": "Γεωμετρικές γραμμές, πλάκες σκυροδέματος, καλλωπιστικά χόρτα"
    },
    "mediterranean": {
      "name": "Μεσογειακός Κήπος",
      "description": "Χαλίκι, ελιές, λεβάντα, γλάστρες τερακότας, περγκόλα"
    },
    "coastal": {
      "name": "Παραθαλάσσιος Κήπος",
      "description": "Αγρωστώδη, θαλασσόξυλα, φυτά ανθεκτικά στο αλάτι"
    },
    "minimalist": {
      "name": "Μινιμαλιστικός Κήπος",
      "description": "Ένα υλικό, λιτή παλέτα φυτών, αρνητικός χώρος"
    },
    "zen": {
      "name": "Κήπος Zen",
      "description": "Χτενισμένο χαλίκι, πέτρες, λιτά φυτά"
    },
    "cottage": {
      "name": "Κήπος Cottage",
      "description": "Ρομαντικός, πυκνή φύτευση, πολυετή λουλούδια"
    },
    "desert": {
      "name": "Ξηρικός κήπος",
      "description": "Ανθεκτικά στην ξηρασία, παχύφυτα, χαλίκι"
    },
    "tropical": {
      "name": "Τροπικός Κήπος",
      "description": "Πλούσιο φύλλωμα, μεγάλα φύλλα, έντονα άνθη"
    },
    "english": {
      "name": "Αγγλικός Κήπος",
      "description": "Περιποιημένο γκαζόν, θάμνοι, πολυεπίπεδα παρτέρια"
    }
  },
  "seasonLabel": "Εποχή",
  "seasons": {
    "none": "Οποιαδήποτε",
    "spring": "Άνοιξη",
    "summer": "Καλοκαίρι",
    "autumn": "Φθινόπωρο",
    "winter": "Χειμώνας"
  },
  "timeOfDayLabel": "Ώρα της ημέρας",
  "timesOfDay": {
    "none": "Οποιαδήποτε",
    "day": "Φως ημέρας",
    "golden_hour": "Χρυσή ώρα",
    "night": "Νύχτα"
  },
  "editRegionReplacementLabel": "Τι θέλεις να αλλάξει;",
  "editRegionReplacementPlaceholder": "π.χ. πρόσθεσε ένα μεγάλο άγαλμα στην είσοδο",
  "editRegionSubmit": "Δημιουργία αλλαγής",
  "editRegionGenerating": "Δημιουργία τροποποιημένης εικόνας…",
  "editRegionMaskRequired": "Σημάδεψε πρώτα την περιοχή που θέλεις να αλλάξεις.",
  "editRegionReplacementRequired": "Πες μας τι να μπει εκεί.",
  "editRegionBrush": "Πινέλο",
  "editRegionUndo": "Αναίρεση",
  "editRegionSize": "Μέγεθος",
  "editRegionClear": "Επαναφορά",
  "errEditGeneric": "Η επεξεργασία απέτυχε. Δοκίμασε ξανά.",
  "lightingPlan": "Σχέδιο φωτισμού",
  "designTips": "Συμβουλές σχεδιασμού",
  "startNew": "Νέο σχέδιο",
  "viewMyDesigns": "Τα σχέδιά μου",
  "favorite": "Αγαπημένο",
  "unfavorite": "Αφαίρεση από τα αγαπημένα",
  "rename": "Μετονομασία",
  "savePromptText": "Συνδέσου για να αποθηκεύσεις το σχέδιο, να το μοιραστείς και να φτιάξεις κι άλλα",
  "guestCreditsLeft": "Δωρεάν σχέδια που απομένουν: {n}. Συνδέσου και ξεκίνα με {total}.",
  "guestCreditsGone": "Αυτό ήταν το τελευταίο σου δωρεάν σχέδιο. Συνδέσου και πάρε {total}.",
  "signInGoogle": "Σύνδεση με Google",
  "signInApple": "Σύνδεση με Apple",
  "signInDesc": "Αποθήκευσε τα σχέδιά σου και βρες τα ανά πάσα στιγμή.",
  "signInPopupBlocked": "Το αναδυόμενο παράθυρο αποκλείστηκε. Επίτρεψε τα αναδυόμενα στις ρυθμίσεις του προγράμματος περιήγησης.",
  "appName": "archelier",
  "navCreate": "Δημιουργία",
  "navGallery": "Γκαλερί",
  "navGio": "Σχεδιαστής",
  "navMain": "Κύρια πλοήγηση",
  "packsTitle": "Αγορά πιστώσεων",
  "packDesigns": "περίπου {n} σχέδια",
  "packBuying": "Άνοιγμα…",
  "packWaiting": "Η πληρωμή ολοκληρώθηκε — προσθήκη πιστώσεων…",
  "packDone": "Οι πιστώσεις προστέθηκαν.",
  "packSlow": "Οι πιστώσεις σου είναι καθ' οδόν. Θα εμφανιστούν σύντομα — δεν χρειάζεται νέα αγορά.",
  "packFailed": "Η αγορά δεν ολοκληρώθηκε. Αν χρεώθηκες και δεν έλαβες πιστώσεις, επικοινώνησε με την υποστήριξη.",
  "gioRole": "Σχεδιαστής χώρων",
  "gioAiNote": "AI",
  "gioSignInBody": "Συνδέσου για να μιλήσεις με τον Gio. Ο Gio βλέπει τις φωτογραφίες και τα παλιά σου σχέδια, προτείνει στυλ και φτιάχνει ή επεξεργάζεται σχέδια απευθείας από τη συνομιλία.",
  "gioGreeting": "Γεια, είμαι ο Gio. Στείλε μου μια φωτογραφία του χώρου σου, μια εικόνα ή σύνδεσμο ενός δωματίου που σου αρέσει ή ένα σχέδιό σου — θα σου προτείνω κατεύθυνση και μπορώ να το δημιουργήσω.",
  "gioChipTaste": "Ποιο είναι το γούστο μου;",
  "gioChipTrend": "Τι είναι τάση αυτή την εβδομάδα;",
  "gioChipPhoto": "Στείλε φωτογραφία χώρου",
  "gioChipMine": "Φέρε ένα σχέδιό μου",
  "gioTyping": "Ο Gio σκέφτεται…",
  "gioPlaceholder": "Ρώτησε τον Gio ή επικόλλησε σύνδεσμο",
  "gioSend": "Αποστολή",
  "gioAttachPhoto": "Επισύναψη φωτογραφίας",
  "gioPickDesign": "Τα σχέδιά μου",
  "gioPickEmpty": "Δεν έχεις ακόμα σχέδια — φτιάξε ένα πρώτα και φέρ' το εδώ.",
  "gioRemove": "Αφαίρεση",
  "gioToday": "Σήμερα",
  "gioNoCredits": "Ξέμεινες από πιστώσεις.",
  "gioError": "Ο Gio δεν μπόρεσε να απαντήσει τώρα. Δοκίμασε ξανά.",
  "gioAlreadyStarting": "Ξεκινάει ήδη — περίμενε λίγο.",
  "gioPhotoSkipped": "Ορισμένες φωτογραφίες δεν προστέθηκαν. Μπορείς να επισυνάψεις έως {n} φωτογραφίες (JPG, PNG, WebP ή HEIC, κάτω από 20 MB).",
  "gioErrPhotos": "Δεν βρέθηκαν οι φωτογραφίες. Πρόσθεσε μια φωτογραφία του χώρου σου και δοκίμασε ξανά.",
  "gioErrPrompt": "Ο Gio δεν μπόρεσε να το μετατρέψει σε σχέδιο. Δοκίμασε να το περιγράψεις διαφορετικά.",
  "gioErrGone": "Αυτό το σχέδιο ή η πρόταση δεν είναι πλέον διαθέσιμη.",
  "gioCreditsLow": "Υπόλοιπο: {n} · {c} ανά μήνυμα, {p} με φωτογραφία",
  "gioCreditsLowFree": "{n} credits ακόμα · η συνομιλία με τον Gio είναι δωρεάν",
  "gioNoCreditsChatFree": "Σου τελείωσαν τα credits για σχέδια — η συνομιλία είναι δωρεάν.",
  "gioDailyLimit": "Πολλή συζήτηση για μία μέρα. Ας το συνεχίσουμε αύριο.",
  "gioCardEdit": "Επεξεργασία",
  "gioCardPhotos": "Έτοιμες φωτογραφίες: {n}",
  "gioCardPhotoFromDesign": "Φωτογραφία από το σχέδιό σου στις {date}",
  "gioCardPhotoFromDesignNoDate": "Φωτογραφία από σχέδιό σου",
  "gioCardPhotoFromChat": "Φωτογραφία που έστειλες εδώ",
  "gioCardPhotoNew": "Νέα φωτογραφία",
  "gioCardNoPhoto": "Καμία φωτογραφία ακόμη",
  "gioCardChangePhoto": "Αλλαγή",
  "gioCardAddPhoto": "Προσθήκη φωτογραφίας",
  "gioCardUploading": "Μεταφόρτωση…",
  "gioCardSame": "Έχεις ήδη ένα σχέδιο {style} από αυτή τη φωτογραφία ({date}).",
  "gioCardSameView": "Προβολή",
  "gioCardSameHint": "Με τα ίδια αιτήματα το αποτέλεσμα θα είναι παρόμοιο. Για να το αλλάξεις, πρόσθεσε αιτήματα παραπάνω, πες το στον Gio στη συνομιλία ή άνοιξέ το στη Δημιουργία.",
  "gioPickPhoto": "Επίλεξε φωτογραφία",
  "gioPickUpload": "Ανέβασε νέα φωτογραφία",
  "gioRunEdit": "Επεξεργασία · {n} πιστώσεις",
  "gioRunGenerate": "Δημιουργία · {n} πιστώσεις",
  "gioRunWithPhoto": "Φωτογραφία & δημιουργία · {n}/φωτ.",
  "gioOpenInCreate": "Άνοιγμα στη Δημιουργία",
  "gioPaintMyself": "Θα σημαδέψω εγώ την περιοχή",
  "gioStarting": "Έναρξη…",
  "gioJobMaking": "Δημιουργία σχεδίου…",
  "gioJobEditing": "Επεξεργασία σχεδίου…",
  "gioJobNotify": "Μπορείς να φύγεις — θα σε ενημερώσω μόλις είναι έτοιμο.",
  "gioJobInvalid": "Αυτή η φωτογραφία δεν μοιάζει με χώρο που μπορώ να σχεδιάσω.",
  "gioJobFailed": "Δεν μπόρεσα να το ολοκληρώσω.",
  "gioJobRefunded": "Οι πιστώσεις σου επιστράφηκαν.",
  "gioJobDone": "Έτοιμο — ρίξε μια ματιά",
  "gioJobGone": "Αυτό το σχέδιο διαγράφηκε.",
  "gioAskAboutDesign": "Ρώτησε τον Gio για αυτό το σχέδιο",
  "navFeed": "Ροή",
  "navMy": "Δικά μου",
  "navAccount": "Ρυθμίσεις",
  "signIn": "Σύνδεση",
  "signOut": "Αποσύνδεση",
  "deleteAccount": "Διαγραφή λογαριασμού",
  "deleteAccountTitle": "Διαγραφή του λογαριασμού σου;",
  "deleteAccountWarn": "Αυτό διαγράφει οριστικά τον λογαριασμό σου και όλα τα συνδεδεμένα δεδομένα. Αυτή η ενέργεια δεν μπορεί να αναιρεθεί.",
  "deleteAccountItem_designs": "Όλα τα σχέδια, οι εικόνες και οι συνομιλίες σου με τον Gio",
  "deleteAccountItem_profile": "Το προφίλ, το όνομα χρήστη και τα αποθηκευμένα στυλ σου",
  "deleteAccountItem_social": "Σχόλια, επισημάνσεις «μου αρέσει», ακολουθήσεις και συλλογές",
  "deleteAccountItem_credits": "Υπόλοιπο πιστώσεων, συμπεριλαμβανομένων των αγορασμένων, και ιστορικό συνδρομών",
  "deleteAccountBilling_web": "Η ενεργή συνδρομή σου στο web θα ακυρωθεί αυτόματα.",
  "deleteAccountBilling_ios": "Η συνδρομή σου στο App Store ή το Google Play δεν θα ακυρωθεί αυτόματα — παρακαλούμε ακύρωσέ την στις ρυθμίσεις συνδρομών του καταστήματος.",
  "deleteAccountFinal": "Θα αποσυνδεθείς αμέσως και δεν θα μπορείς να ανακτήσεις αυτόν τον λογαριασμό.",
  "deleteAccountConfirm": "Διαγραφή λογαριασμού",
  "deleteAccountSubmitting": "Διαγραφή…",
  "deleteAccountError": "Δεν ήταν δυνατή η διαγραφή του λογαριασμού σου. Δοκίμασε ξανά.",
  "myDesigns": "Τα σχέδιά μου",
  "language": "Γλώσσα",
  "support": "Υποστήριξη",
  "terms": "Όροι Χρήσης",
  "privacy": "Πολιτική Απορρήτου",
  "signInTerms": "Με τη σύνδεση συμφωνείς με: {terms} και {privacy}.",
  "onboardingSkip": "Παράλειψη",
  "onboardingNext": "Επόμενο",
  "onboardingStart": "Ξεκίνα",
  "tourTitle": "Περιήγηση στο archelier",
  "tourCreate": "Ξεκίνα εδώ. Φωτογράφισε ή ανέβασε ένα δωμάτιο, μια πρόσοψη ή έναν κήπο, διάλεξε στυλ και το νέο σχέδιο είναι έτοιμο σε λίγο.",
  "tourGallery": "Γκαλερί — τα πιο δημοφιλή στυλ στο archelier αυτή την εβδομάδα. Πάτα ένα για να το δοκιμάσεις στον χώρο σου.",
  "tourGio": "Ο Gio είναι ο σχεδιαστής σου. Δείξε μια φωτογραφία και πες τι θέλεις — ο Gio προτείνει στυλ, μετά δημιουργεί ή επεξεργάζεται το σχέδιο.",
  "tourMy": "Τα σχέδιά σου συγκεντρώνονται στα «Δικά μου». Διόρθωσε ένα σημείο με το πινέλο ή περιγράφοντάς το, μετά κατέβασε ή μοιράσου το.",
  "tourStart": "Γύρνα σε αυτό το κουμπί όποτε θέλεις για νέο σχέδιο. Ας ξεκινήσουμε με μία φωτογραφία.",
  "tourReplay": "Επανάληψη περιήγησης",
  "onboarding": [
    {
      "icon": "photo_camera",
      "title": "Φωτογραφία, σκίτσο ή μεταφόρτωση",
      "desc": "Μια φωτογραφία από το κινητό είναι ιδανική, αλλά το archelier διαβάζει και χειρόγραφα σκίτσα, κατόψεις, όψεις και 3D μοντέλα — όλα αυτόματα."
    },
    {
      "icon": "style",
      "title": "19+ στυλ, 4 έξυπνες λειτουργίες",
      "desc": "Διάλεξε ένα έτοιμο στυλ, γράψε δική σου περιγραφή, πάρε το ύφος από μια φωτογραφία που σ' αρέσει ή χρησιμοποίησε τις λειτουργίες Καθαρισμού / Διάταξης."
    },
    {
      "icon": "brush",
      "title": "Επεξεργάσου μόνο ό,τι θέλεις",
      "desc": "Δεν σ' αρέσει μια γωνία; Πέρνα τη με το πινέλο και πες στην AI τι να βάλει εκεί. Το υπόλοιπο δωμάτιο μένει ολόιδιο."
    },
    {
      "icon": "auto_awesome",
      "title": "Δοκίμασέ το τώρα",
      "desc": "Παίρνεις δωρεάν πιστώσεις κάθε μέρα. Ανέβασε μια φωτογραφία και το πρώτο σου σχέδιο θα είναι έτοιμο σε περίπου ένα λεπτό."
    }
  ],
  "onboardTabFeedTitle": "Εξερεύνησε πρώτα",
  "onboardTabFeedDesc": "Δες δημιουργίες άλλων και βρες έμπνευση για τον χώρο σου.",
  "onboardTabCreateTitle": "Σχεδίασε με AI",
  "onboardTabCreateDesc": "Ανέβασε φωτογραφία, σκίτσο ή κάτοψη — η AI θα δημιουργήσει ένα νέο σχέδιο.",
  "onboardTabMyTitle": "Αποθήκευση & διαχείριση",
  "onboardTabMyDesc": "Τα σχέδιά σου συγκεντρώνονται εδώ. Μοιράσου τα στη ροή ή κατέβασέ τα όποτε θέλεις.",
  "onboardTabGioTitle": "Ρώτα τον Gio",
  "onboardTabGioDesc": "Ο Gio, ο σχεδιαστής σου, προτείνει στυλ από τις φωτογραφίες σου και δημιουργεί ή επεξεργάζεται σχέδια απευθείας στη συνομιλία.",
  "myDesignsTitle": "Τα σχέδιά μου",
  "signInToSee": "Συνδέσου για να δεις τα σχέδιά σου",
  "signInToSeeDesc": "Τα αποθηκευμένα σχέδιά σου θα εμφανιστούν εδώ.",
  "loadingDesigns": "Φόρτωση σχεδίων…",
  "errLoadDesigns": "Αποτυχία φόρτωσης σχεδίων. Δοκίμασε ξανά.",
  "retry": "Δοκίμασε ξανά",
  "noFavorites": "Δεν υπάρχουν αγαπημένα ακόμα.",
  "noDesigns": "Δεν υπάρχουν σχέδια ακόμα. Δημιούργησε το πρώτο σου!",
  "createDesign": "Δημιουργία σχεδίου",
  "loadMore": "Φόρτωση περισσότερων",
  "loading": "Φόρτωση…",
  "errDesignNotFound": "Το σχέδιο δεν βρέθηκε.",
  "errLoadDesign": "Αποτυχία φόρτωσης σχεδίου.",
  "errDeleteDesign": "Αποτυχία διαγραφής. Δοκίμασε ξανά.",
  "renameTitle": "Μετονομασία σχεδίου",
  "renamePlaceholders": [
    "Ανανέωση σαλονιού v1",
    "Κουζίνα — φωτεινή εκδοχή",
    "Ανακαίνιση στούντιο",
    "Υπνοδωμάτιο, θερμοί τόνοι",
    "Μπαλκόνι σχέδιο Β",
    "Διαμόρφωση γραφείου",
    "Προσχέδιο εσωτερικού καφέ",
    "Μπροστινή αυλή v2"
  ],
  "save": "Αποθήκευση",
  "cancel": "Ακύρωση",
  "deleteTitle": "Διαγραφή σχεδίου;",
  "deleteDesc": "Αυτό θα διαγράψει οριστικά αυτό το σχέδιο και όλες τις εικόνες του. Η ενέργεια δεν αναιρείται.",
  "delete": "Διαγραφή",
  "deleting": "Διαγραφή…",
  "postToFeed": "Δημοσίευση στη ροή",
  "postedToFeedTitle": "Δημοσιεύτηκε στη ροή",
  "postedToFeedDesc": "Άλλοι χρήστες μπορούν πλέον να δουν και να κάνουν like σε αυτό το σχέδιο στη ροή.",
  "captionTitle": "Προσθήκη λεζάντας",
  "captionPlaceholder": "Πες μας γιατί ανανέωσες αυτόν τον χώρο (προαιρετικά)",
  "captionEdit": "Επεξεργασία λεζάντας",
  "captionPost": "Δημοσίευση",
  "captionSave": "Αποθήκευση",
  "captionCancel": "Ακύρωση",
  "viewFeed": "Προβολή ροής",
  "generationInProgress": "Σχεδιασμός του χώρου σου…",
  "generationKeepBrowsing": "Περιηγήσου ελεύθερα — θα σε ενημερώσουμε μόλις είναι έτοιμο",
  "generationDone": "Το σχέδιό σου είναι έτοιμο!",
  "generationTapToOpen": "Πάτα Άνοιγμα για προβολή",
  "generationFailedHint": "Δεν χρεώθηκαν πιστώσεις. Προσπάθησε ξανά.",
  "open": "Άνοιγμα",
  "copy": "Αντιγραφή",
  "copied": "Αντιγράφηκε!",
  "share": "Κοινοποίηση",
  "downloadImages": "Λήψη εικόνων AI",
  "download": "Λήψη",
  "downloadWatermarkHint": "Μια μικρή υπογραφή του archelier βρίσκεται κάτω δεξιά.",
  "modes": {
    "redesign": "Ανασχεδιασμός",
    "staging": "Επίπλωση άδειου χώρου"
  },
  "styleUsed": "Στυλ σχεδίου",
  "customDescLabel": "Προσαρμοσμένη περιγραφή:",
  "additionalReqLabel": "Επιπλέον αιτήματα:",
  "useStyleAgain": "Χρήση αυτού του στυλ ξανά",
  "feedTitle": "Κοινότητα",
  "feedEmpty": "Δεν υπάρχουν δημόσια σχέδια ακόμα. Κάνε την αρχή!",
  "feedSortLatest": "Πρόσφατα",
  "feedSortPopular": "Δημοφιλή",
  "feedFilterAll": "Όλα",
  "useThisStyle": "Δοκίμασε αυτό το στυλ",
  "sourceDesignBanner": "Βασισμένο στο «{name}»",
  "galleryPickBanner": "Δημιουργία με {name}",
  "signInToLike": "Συνδέσου για να κάνεις like σε σχέδια",
  "tryApp": "Δοκίμασε το archelier",
  "privateTitle": "Αυτό το σχέδιο είναι ιδιωτικό",
  "privateDesc": "Ο κάτοχος δεν έχει κάνει αυτό το σχέδιο δημόσιο.",
  "linkNotFoundTitle": "Αυτός ο σύνδεσμος δεν είναι διαθέσιμος",
  "linkNotFoundDesc": "Το σχέδιο ενδέχεται να έχει διαγραφεί ή ο σύνδεσμος είναι ελλιπής.",
  "createWithApp": "Δημιούργησε με το archelier",
  "shareViewCTA": "Θέλεις να ανασχεδιάσεις τον δικό σου χώρο;",
  "styles": {
    "modern": {
      "name": "Μοντέρνο",
      "description": "Καθαρές γραμμές, ουδέτεροι τόνοι, μινιμαλιστική σύγχρονη αισθητική"
    },
    "scandinavian": {
      "name": "Σκανδιναβικό",
      "description": "Φωτεινό, φυσικά υλικά, ζεστή σκανδιναβική ατμόσφαιρα"
    },
    "ikea": {
      "name": "IKEA",
      "description": "Λειτουργικό, προσιτό, έξυπνο σκανδιναβικό καθημερινό ντιζάιν"
    },
    "japandi": {
      "name": "Japandi",
      "description": "Ο ιαπωνικός μινιμαλισμός συναντά τη σκανδιναβική ζεστασιά"
    },
    "industrial": {
      "name": "Βιομηχανικό",
      "description": "Ακατέργαστα υλικά, εμφανή στοιχεία, αισθητική αστικού loft"
    },
    "coastal": {
      "name": "Παραθαλάσσιο",
      "description": "Ανάλαφρη, φωτεινή κομψότητα παραθαλάσσιου σπιτιού"
    },
    "classic": {
      "name": "Κλασικό",
      "description": "Διαχρονική κομψότητα, πλούσια υφάσματα, περίτεχνες λεπτομέρειες"
    },
    "artdeco": {
      "name": "Art Deco",
      "description": "Έντονη γεωμετρία, χρυσές πινελιές, λαμπερή πολυτέλεια των '20s"
    },
    "midcentury": {
      "name": "Mid-Century Modern",
      "description": "Οργανικές φόρμες, ζεστό ξύλο, ρετρό μοντέρνα γοητεία 50s-60s"
    },
    "maximalist": {
      "name": "Μαξιμαλιστικό",
      "description": "Έντονα μοτίβα, πλούσιες στρώσεις, φιλοσοφία «more is more»"
    },
    "vintage": {
      "name": "Vintage",
      "description": "Νοσταλγική γοητεία, αντίκες, ζεστή ρετρό παλέτα"
    },
    "bohemian": {
      "name": "Μποέμ",
      "description": "Ανεπιτήδευτο στυλ, πολύχρωμα υφάσματα, καλλιτεχνικός εκλεκτικισμός"
    },
    "tropical": {
      "name": "Τροπικό",
      "description": "Πλούσια φυτά, ρατάν, ανάλαφρη αίσθηση θερέτρου"
    },
    "cottagecore": {
      "name": "Cottagecore",
      "description": "Ρομαντική αγγλική εξοχή, φλοράλ, απαλά παστέλ"
    },
    "rustic": {
      "name": "Ρουστίκ",
      "description": "Φυσικό ξύλο, πέτρα, ζεστή χωριάτικη γοητεία"
    },
    "wabisabi": {
      "name": "Wabi-Sabi",
      "description": "Ατελής ομορφιά, φυσικές υφές, ήρεμος ιαπωνικός ασκητισμός"
    },
    "gothic": {
      "name": "Γοτθικό",
      "description": "Ατμοσφαιρικό σκοτάδι, βελούδο, περίτεχνες σιλουέτες"
    },
    "cyberpunk": {
      "name": "Cyberpunk",
      "description": "Φουτουρισμός με νέον, επιφάνειες hi-tech, αστική δυστοπία"
    },
    "taisho_romance": {
      "name": "Taisho Romance",
      "description": "Ιαπωνία των αρχών του 20ού αιώνα συναντά τη δυτική Art Nouveau"
    },
    "biophilic": {
      "name": "Βιοφιλικό",
      "description": "Φυτά παντού, φυσικό φως, οργανικές υφές"
    },
    "cozy": {
      "name": "Ζεστό",
      "description": "Ζεστό, απαλό, φιλόξενο — άνεση σε στυλ hygge"
    },
    "gaming": {
      "name": "Gaming",
      "description": "Φωτισμός RGB, κομψή τεχνολογία, ατμοσφαιρικό setup"
    },
    "minimalist": {
      "name": "Μινιμαλιστικό",
      "description": "Λιτές γραμμές, χωρίς ακαταστασία, αρνητικός χώρος"
    },
    "mediterranean": {
      "name": "Μεσογειακό",
      "description": "Ασβεστωμένοι τοίχοι, τερακότα, καμάρες, φυσική πέτρα"
    },
    "luxury": {
      "name": "Quiet Luxury",
      "description": "Πολυτελή υλικά, διακριτική παλέτα, λιτή κομψότητα"
    },
    "dark_academia": {
      "name": "Dark Academia",
      "description": "Ατμοσφαιρική βιβλιοθήκη — μπορντό, ορείχαλκος, στοίβες βιβλίων"
    },
    "organic_modern": {
      "name": "Οργανικό Μοντέρνο",
      "description": "Μοντέρνες φόρμες σε φυσικά, ακατέργαστα υλικά"
    },
    "farmhouse": {
      "name": "Αγροικία",
      "description": "Επένδυση ξύλου, παραδοσιακός νεροχύτης, ζεστό χωριάτικο στυλ"
    },
    "halloween": {
      "name": "Halloween",
      "description": "Κολοκύθες, κεριά, ατμοσφαιρικό φθινοπωρινό σκοτάδι"
    },
    "christmas": {
      "name": "Χριστουγεννιάτικο",
      "description": "Δέντρο, γιρλάντες, ζεστά φώτα, γιορτινή ατμόσφαιρα"
    },
    "lunar_new_year": {
      "name": "Σεληνιακή Πρωτοχρονιά",
      "description": "Κόκκινο και χρυσό, φαναράκια, τυχερά μοτίβα"
    },
    "spring_blossom": {
      "name": "Ανοιξιάτικη Άνθιση",
      "description": "Άνθη κερασιάς, παστέλ, φρέσκο ανάλαφρο φως"
    },
    "custom": {
      "name": "Δικό σου στυλ",
      "description": "Περίγραψε το δικό σου μοναδικό στυλ"
    },
    "reference": {
      "name": "Αναφορά",
      "description": "Αντιστοίχιση τόνων, υλικών και διάθεσης από φωτογραφία σου"
    },
    "floorplan": {
      "name": "Κάτοψη",
      "description": "3D σχέδιο ή καθαρή σχεδίαση από την κάτοψή σου"
    },
    "cleanup": {
      "name": "Καθαρισμός",
      "description": "Τακτοποίησε την ακαταστασία ή άδειασε το δωμάτιο — εσύ επιλέγεις"
    },
    "layout": {
      "name": "Διάταξη",
      "description": "Τα ίδια έπιπλα, εξυπνότερη διάταξη — ροή ή ευρυχωρία"
    }
  },
  "langMismatchNotice": "Αυτή η ανάλυση δημιουργήθηκε στα {lang}.",
  "pricingTitle": "Πλάνα που προσαρμόζονται σε εσένα",
  "pricingSubtitle": "Ξεκίνα δωρεάν. Αναβάθμισε όταν χρειαστείς περισσότερες δημιουργίες και premium δυνατότητες.",
  "pricePerMonth": "/ μήνα",
  "trialCta": "Ξεκίνα δωρεάν δοκιμή {n} ημερών",
  "accountPlanFreeTitle": "Ο λογαριασμός σου είναι ΔΩΡΕΑΝ",
  "accountPlanProTitle": "Έχεις το Pro",
  "accountPlanTrialTitle": "Έχεις το Pro — Δωρεάν δοκιμή",
  "proTrialBadge": "Δοκιμή",
  "proTrialDaysLeft": "Απομένουν {n} ημέρες στη δωρεάν δοκιμή σου",
  "proTrialIntroTitle": "Απόκτησε 2 εβδομάδες Pro — δωρεάν",
  "proTrialIntroDesc": "Γράψου και ξεκίνα με {n} δωρεάν πιστώσεις.",
  "proTrialFeatures": "Μετά {n} ακόμα δωρεάν κάθε μέρα. Χωρίς συνδρομή, ποτέ.",
  "welcomeSkip": "Συνέχεια χωρίς λογαριασμό",
  "landingHeadline": "ανασχεδίασε κάθε δωμάτιο, σε δευτερόλεπτα.",
  "landingTagline": "Βγάλε φωτογραφία, διάλεξε στυλ, πάρε φωτορεαλιστική σχεδίαση. Δωρεάν κάθε μέρα, χωρίς συνδρομή.",
  "landingOpenWeb": "Ή συνέχισε στον ιστότοπο →",
  "landingFeat1": "AI σχεδίαση εσωτερικών χώρων",
  "landingFeat2": "Φωτορεαλιστικό",
  "landingFeat3": "50+ στυλ",
  "landingFeat4": "Κήπος & εξωτερικοί χώροι",
  "landingFeat5": "Δωρεάν κάθε μέρα",
  "landingStoreOn": "Λήψη από το",
  "landingStoreGet": "Διαθέσιμο στο",
  "lp": {
    "metaTitle": "archelier — AI Design Εσωτερικών Χώρων από Φωτογραφία, Σχέδιο ή Κάτοψη",
    "metaDescription": "Βγάλε μια φωτογραφία οποιουδήποτε δωματίου και πάρε έναν φωτορεαλιστικό ανασχεδιασμό σε περίπου ένα λεπτό. 48 στυλ για εσωτερικούς, εξωτερικούς χώρους και κήπους, 3D κατόψεις, επεξεργασία με πινέλο και ένας AI designer για chat. Δωρεάν κάθε μέρα.",
    "heroEyebrow": "AI design εσωτερικών χώρων",
    "scrollCue": "Δες πώς λειτουργεί",
    "webCta": "Δοκίμασέ το δωρεάν στον browser",
    "orApp": "Ή κατέβασε την εφαρμογή",
    "qrHint": "Σάρωσε με την κάμερα του κινητού σου. Η εφαρμογή θα σε ειδοποιήσει μόλις το σχέδιό σου είναι έτοιμο.",
    "showEyebrow": "Πριν & μετά",
    "showTitle": "Μία φωτογραφία. Ένα εντελώς νέο δωμάτιο.",
    "showBody": "Πραγματικά αποτελέσματα με το archelier. Σύρε για σύγκριση.",
    "before": "Πριν",
    "after": "Μετά",
    "tabRoom": "Σαλόνι",
    "tabEmpty": "Άδειο δωμάτιο",
    "tabSketch": "Σκίτσο",
    "tabPlan": "Κάτοψη",
    "tabExterior": "Εξωτερικός χώρος",
    "capRoom": "Rustic — η ίδια κουζίνα και το σαλόνι, πιο ζεστά.",
    "capEmpty": "Scandinavian — ένα άδειο δωμάτιο, επιπλωμένο.",
    "capSketch": "Japandi — ένα γραμμικό σχέδιο, αποδοσμένο ως πραγματικός χώρος.",
    "capPlan": "Λειτουργία κάτοψης — μια 2D κάτοψη γίνεται 3D προβολή όλου του σπιτιού.",
    "capExterior": "Minimalist — μια πολυσύχναστη πρόσοψη, ανασχεδιασμένη.",
    "howEyebrow": "Πώς λειτουργεί",
    "howTitle": "Τρία βήματα, περίπου ένα λεπτό.",
    "how1Title": "Βγάλε μια φωτογραφία",
    "how1Body": "Οποιοδήποτε δωμάτιο όπως είναι — ή ένα σκίτσο, μια κάτοψη ή ένα 3D screenshot. Έως και 3 γωνίες του ίδιου χώρου.",
    "how2Title": "Διάλεξε ένα στυλ",
    "how2Body": "Επίλεξε ένα από τα 48 στυλ, περιέγραψε το δικό σου σε μια πρόταση ή ανέβασε μια φωτογραφία που σου αρέσει.",
    "how3Title": "Πάρε το σχέδιό σου",
    "how3Body": "Ένα φωτορεαλιστικό render του χώρου σου, με λίστα επίπλων, παλέτα χρωμάτων και σχέδιο φωτισμού.",
    "stylesEyebrow": "Στυλ",
    "stylesTitle": "48 στυλ, τρία είδη χώρων.",
    "stylesBody": "28 για εσωτερικούς χώρους, 11 για εξωτερικούς, 9 για κήπους — συν εποχιακά στυλ για Halloween, Χριστούγεννα, Σεληνιακό Νέο Έτος και άνοιξη.",
    "stylesInterior": "Εσωτερικός χώρος",
    "stylesExterior": "Εξωτερικός χώρος",
    "stylesGarden": "Κήπος",
    "stylesCta": "Περιηγήσου στη γκαλερί στυλ",
    "modesEyebrow": "Πέρα από τα στυλ",
    "modesTitle": "Πέντε ακόμα τρόποι να διαμορφώσεις έναν χώρο.",
    "modeCustomTitle": "Προσαρμοσμένο στυλ",
    "modeCustomBody": "Περιέγραψε το στυλ σε μια πρόταση και αποθήκευσέ το για την επόμενη φορά.",
    "modeReferenceTitle": "Αναφορά",
    "modeReferenceBody": "Ανέβασε μια φωτογραφία που σου αρέσει και δανείσου το ύφος, τα υλικά και την παλέτα της — όχι τη διάταξη.",
    "modeCleanupTitle": "Καθαρισμός",
    "modeCleanupBody": "Καθάρισε την ακαταστασία και δες το δωμάτιο άδειο.",
    "modeLayoutTitle": "Διάταξη",
    "modeLayoutBody": "Αναδιάταξε τα υπάρχοντα έπιπλα αντί να τα αντικαταστήσεις.",
    "modePlanTitle": "Κάτοψη",
    "modePlanBody": "Μετάτρεψε μια κάτοψη σε 3D προβολή όλου του σπιτιού ή ένα πρόχειρο σκίτσο σε καθαρό σχέδιο.",
    "editEyebrow": "Επεξεργασία με πινέλο",
    "editTitle": "Άλλαξε ένα πράγμα τη φορά.",
    "editBody": "Δεν σου αρέσει μόνο ο καναπές; Κύκλωσέ τον και γράψε τι θέλεις στη θέση του. Το archelier επανασχεδιάζει μόνο αυτή την περιοχή και αφήνει το υπόλοιπο δωμάτιο ανέπαφο — το ίδιο ισχύει για το χρώμα των τοίχων, τα χαλιά, τον φωτισμό και τους πίνακες.",
    "editPrompt": "Ένας vintage δερμάτινος καναπές",
    "shopTitle": "Αγόρασε ό,τι βλέπεις.",
    "shopBody": "Κάθε σχέδιο συνοδεύεται από λίστα επίπλων, παλέτα χρωμάτων και σχέδιο φωτισμού, ενώ κάθε κομμάτι συνδέεται με αναζήτηση για παρόμοια προϊόντα.",
    "gioEyebrow": "Gio",
    "gioTitle": "Συζήτησέ το με έναν designer.",
    "gioBody": "Ο Gio είναι ο AI designer χώρου σου, σε δική του καρτέλα. Στείλε μια φωτογραφία του δωματίου σου, μια εικόνα ή σύνδεσμο ενός χώρου που σου αρέσει ή ένα από τα σχέδιά σου. Ο Gio προτείνει μια κατεύθυνση και δημιουργεί ή επεξεργάζεται το σχέδιο για εσένα, απευθείας στο chat.",
    "gioRole": "Designer χώρου",
    "gioUser": "Αυτή είναι η κουζίνα και η τραπεζαρία μου. Φαίνεται λίγο κρύα. Καμιά ιδέα;",
    "gioReply": "Ας προσθέσουμε ζεστό ξύλο, απαλά υφάσματα και χαμηλό φωτισμό περιβάλλοντος αντί για ψυχρές επιφάνειες. Ορίστε μια κατεύθυνση:",
    "gioCardTitle": "Ζεστασιά Japandi",
    "gioCardBody": "Η φυσική δρυς και ο σοβάς με υφή δίνουν αμέσως ζεστασιά στον χώρο.",
    "gioCardAction": "Δημιούργησέ το",
    "priceEyebrow": "Τιμές",
    "priceTitle": "Δωρεάν κάθε μέρα. Χωρίς συνδρομή.",
    "price1": "Δωρεάν σχέδια κάθε μέρα, που ανανεώνονται τα μεσάνυχτα",
    "price2": "Bonus όταν δημιουργείς λογαριασμό",
    "price3": "Προσκάλεσε έναν φίλο και κερδίστε και οι δύο περισσότερα",
    "price4": "Χρειάζεσαι περισσότερα; Συμπλήρωσε με ένα πακέτο credits",
    "privacyTitle": "Οι φωτογραφίες σου παραμένουν δικές σου.",
    "privacyBody": "Οι φωτογραφίες, τα prompt και τα σχέδιά σου δεν χρησιμοποιούνται ποτέ για την εκπαίδευση μοντέλων AI ή για διαφημίσεις. Τα σχέδιά σου παραμένουν ιδιωτικά εκτός αν τα κοινοποιήσεις.",
    "faqTitle": "Ερωτήσεις",
    "faq1Q": "Τι είναι το archelier;",
    "faq1A": "Το archelier (Architect + Atelier) είναι μια εφαρμογή AI εσωτερικής διακόσμησης για το κινητό και το web. Στρέψε την κάμερα σε ένα δωμάτιο, επίλεξε στυλ και λάβε έναν φωτορεαλιστικό επανασχεδιασμό του χώρου σου, με κάθε έπιπλο ονομασμένο και με σύνδεσμο. Λειτουργεί για εσωτερικούς, εξωτερικούς χώρους και κήπους.",
    "faq2Q": "Πώς λειτουργεί;",
    "faq2A": "Βγάλε μια φωτογραφία του δωματίου ή ανέβασε ένα σκίτσο, μια κάτοψη ή ένα 3D screenshot. Επίλεξε ένα από τα 48 στυλ, περίγραψε το δικό σου ή ανέβασε μια φωτογραφία αναφοράς. Σε περίπου ένα λεπτό παίρνεις ένα φωτορεαλιστικό render του χώρου σου, μαζί με λίστα επίπλων, παλέτα χρωμάτων και σχέδιο φωτισμού.",
    "faq3Q": "Είναι δωρεάν το archelier;",
    "faq3A": "Ναι. Δεν υπάρχει συνδρομή. Όλοι παίρνουν δωρεάν σχέδια κάθε μέρα, που ανανεώνονται τα μεσάνυχτα, συν ένα bonus για τη δημιουργία λογαριασμού και για την πρόσκληση ενός φίλου. Αν θέλεις περισσότερα, μπορείς να αγοράσεις ένα πακέτο credits.",
    "faq4Q": "Μπορεί να μετατρέψει μια κάτοψη σε 3D rendering;",
    "faq4A": "Ναι. Η λειτουργία κάτοψης μετατρέπει μια 2D κάτοψη σε 3D προβολή όλου του σπιτιού στο στυλ που επιλέγεις. Μπορεί επίσης να μετατρέψει ένα χειρόγραφο σκίτσο ή μια θολή κάτοψη σε καθαρό σχέδιο ή έγχρωμη κάτοψη.",
    "faq5Q": "Μπορώ να προσαρμόσω το στυλ μιας φωτογραφίας που μου αρέσει;",
    "faq5A": "Ναι. Επίλεξε το στυλ Αναφοράς και ανέβασε τη φωτογραφία έμπνευσης. Το archelier δανείζεται τον τόνο, τα υλικά και την παλέτα της και τα εφαρμόζει στο δωμάτιό σου χωρίς να αντιγράφει τη διαρρύθμιση.",
    "faq6Q": "Μπορώ να αλλάξω μόνο ένα μέρος ενός σχεδίου;",
    "faq6A": "Ναι. Κύκλωσε την περιοχή που θέλεις να αλλάξεις — τον καναπέ, το χαλί, έναν τοίχο — και γράψε τι θέλεις στη θέση του. Μόνο αυτή η περιοχή ανανεώνεται, ενώ το υπόλοιπο δωμάτιο παραμένει όπως ήταν.",
    "faq7Q": "Τι είναι ο Gio;",
    "faq7A": "Ο Gio είναι ο AI designer χώρου του archelier. Στείλε του μια φωτογραφία του δωματίου σου, μια εικόνα ή σύνδεσμο ενός χώρου που σου αρέσει ή ένα από τα σχέδιά σου. Ο Gio προτείνει μια κατεύθυνση, δημιουργεί ή επεξεργάζεται το σχέδιο για εσένα στο chat και απαντά σε ερωτήσεις σχετικά με χρώματα, προϋπολογισμό και φωτισμό.",
    "faq8Q": "Χρησιμοποιούνται οι φωτογραφίες μου για την εκπαίδευση AI;",
    "faq8A": "Όχι. Το archelier δεν χρησιμοποιεί τις φωτογραφίες, τα prompt ή τα σχέδιά σου για την εκπαίδευση μοντέλων AI ή για διαφημίσεις. Τα σχέδιά σου παραμένουν ιδιωτικά στον λογαριασμό σου εκτός αν τα κοινοποιήσεις.",
    "faq9Q": "Πού μπορώ να χρησιμοποιήσω το archelier;",
    "faq9A": "Στο App Store, στο Google Play και στο web στο archelier.co. Ο λογαριασμός και τα σχέδιά σου συγχρονίζονται παντού. Το archelier είναι διαθέσιμο σε 11 γλώσσες.",
    "ctaTitle": "Επανασχεδίασε το δωμάτιό σου σήμερα.",
    "ctaBody": "Στο κινητό σου και στο web. Τα σχέδιά σου συγχρονίζονται παντού.",
    "langLabel": "Γλώσσα"
  },
  "upgradeToPro": "Αναβάθμιση σε Pro",
  "creditsPerMonth": "{n} πιστώσεις ανά μήνα",
  "planFreeName": "Δωρεάν",
  "planFreeTagline": "Δοκίμασε το archelier με λίγα σχέδια κάθε μήνα.",
  "planProName": "Pro",
  "planProTagline": "Για τακτικούς σχεδιαστές που θέλουν ποιοτικά αποτελέσματα.",
  "planStudioName": "Studio",
  "planStudioTagline": "Για προχωρημένους χρήστες, ομάδες και επαγγελματική χρήση.",
  "planFeatWatermark": "Περιλαμβάνει υδατογράφημα \"archelier\"",
  "planFeatNoWatermark": "Χωρίς υδατογράφημα σε αποθηκευμένα ή κοινόχρηστα σχέδια",
  "planFeatUnlimited": "Απεριόριστες δημιουργίες σχεδίων AI",
  "planFeatUnlimitedChat": "Απεριόριστο AI chat ανά σχέδιο (δωρεάν: 3 μηνύματα)",
  "planFeatUnlimitedEdit": "Απεριόριστες επεξεργασίες περιοχών",
  "planFeatFeed": "Κοινοποίηση στο feed",
  "planFeatEverythingPro": "Όλα όσα περιλαμβάνει το Pro",
  "planFeatCommercial": "Δικαιώματα εμπορικής χρήσης",
  "planFeatApiAccess": "Πρόσβαση στο API (σύντομα)",
  "planCtaSubscribe": "Εγγραφή",
  "planCtaCurrent": "Το τρέχον πλάνο σου",
  "planPopular": "Δημοφιλέστερο",
  "signInToSubscribe": "Σύνδεση για εγγραφή",
  "signInToBuy": "Σύνδεση για αγορά",
  "trialNote": "Δωρεάν δοκιμή {n} ημερών",
  "creditPacksTitle": "Ή ανανέωσε με πακέτα πιστώσεων",
  "creditPacksSubtitle": "Εφάπαξ αγορά, χωρίς απαίτηση συνδρομής.",
  "packStarterName": "Πακέτο Starter",
  "packStandardName": "Πακέτο Standard",
  "packProName": "Πακέτο Pro",
  "packCreditsAmount": "{n} πιστώσεις",
  "packCtaBuy": "Αγορά",
  "pricingFootnote": "Οι τιμές εμφανίζονται σε USD. Οι φόροι υπολογίζονται στο ταμείο. Ακύρωση ανά πάσα στιγμή.",
  "errBillingGeneric": "Κάτι πήγε στραβά κατά την επεξεργασία του αιτήματός σου. Δοκίμασε ξανά.",
  "accountTitle": "Ρυθμίσεις",
  "accountPlanSection": "Συνδρομή",
  "accountCreditsSection": "Πιστώσεις",
  "accountCreditsDesc": "Οι πιστώσεις χρησιμοποιούνται για τη δημιουργία σχεδίων. Πρόσθεσε ανά πάσα στιγμή.",
  "viewPlans": "Δες τα πακέτα",
  "changePlan": "Αλλαγή πακέτου",
  "manageBilling": "Διαχείριση χρεώσεων",
  "manageBillingWebHint": "Αν γράφτηκες από το web, μπορείς να το διαχειριστείς στο archelier.co.",
  "buyCreditPack": "Αγορά πακέτου πιστώσεων",
  "subRenewsAt": "Ανανεώνεται στις {date}",
  "subEndsAt": "Λήγει στις {date}",
  "trialEndsAt": "Η δωρεάν δοκιμή λήγει στις {date} — μετατρέπεται σε $9.99/μήνα",
  "trialCancelEndsAt": "Η δοκιμή λήγει στις {date} — η συνδρομή δεν θα ανανεωθεί",
  "subStatus_past_due": "Εκπρόθεσμη πληρωμή — ενημέρωσε τον τρόπο πληρωμής σου.",
  "subStatus_canceled": "Η συνδρομή ακυρώθηκε.",
  "subStatus_unpaid": "Απλήρωτη συνδρομή.",
  "subStatus_trialing": "Δωρεάν δοκιμή σε ισχύ.",
  "account": "Λογαριασμός",
  "pricing": "Τιμές",
  "upgrade": "Αναβάθμιση",
  "inviteTitle": "Προσκάλεσε φίλους & κέρδισε πιστώσεις",
  "inviteSubtitle": "Όταν ένας φίλος εγγραφεί με τον σύνδεσμό σου, παίρνεις +{inviter} πιστώσεις κι εκείνος +{invitee}.",
  "inviteFriends": "Πρόσκληση φίλων",
  "inviteSignInHint": "Συνδέσου για να λάβεις τον προσωπικό σου σύνδεσμο.",
  "yourReferralCode": "Ο σύνδεσμος πρόσκλησής σου",
  "inviteCodeLoading": "Προετοιμασία συνδέσμου πρόσκλησης…",
  "inviteLinkHint": "Όποιος γραφτεί με τον σύνδεσμό σου παίρνει +{n} δωρεάν πιστώσεις.",
  "copyLink": "Αντιγραφή συνδέσμου",
  "shareLink": "Κοινοποίηση συνδέσμου",
  "inviteShareText": "Ανασχεδίασε τον χώρο σου με AI στο archelier. Χρησιμοποίησε τον σύνδεσμό μου για +{n} δωρεάν πιστώσεις.",
  "redeemTitle": "Έχεις κωδικό;",
  "redeemDesc": "Βάλε έναν κωδικό πρόσκλησης από φίλο ή έναν κωδικό προσφοράς για δωρεάν πιστώσεις.",
  "copyCode": "Αντιγραφή κωδικού",
  "errRefSelf": "Δεν μπορείς να χρησιμοποιήσεις τον δικό σου κωδικό πρόσκλησης.",
  "landingInviteTitle": "Ένας φίλος σε προσκάλεσε — παίρνετε και οι δύο +{n} πιστώσεις.",
  "landingInviteAutoIos": "Εγκατάστησε την εφαρμογή, μετά πάτα ξανά αυτόν τον σύνδεσμο πρόσκλησης — η εφαρμογή θα ανοίξει και το μπόνους σου θα προστεθεί μόλις εγγραφείς.",
  "landingInviteAutoAndroid": "Κάνε εγκατάσταση από το κουμπί Google Play παρακάτω και εγγράψου — το μπόνους σου προστίθεται αυτόματα. Αν όχι, βάλε αυτόν τον κωδικό στις Ρυθμίσεις → Πρόσκληση φίλων.",
  "landingInviteDesktop": "Κάνε εγγραφή εδώ και το μπόνους σου θα προστεθεί αμέσως. Για να το λάβεις στην εφαρμογή του κινητού, σάρωσε το QR code και ακολούθησε τα βήματα στο τηλέφωνό σου.",
  "promoTitle": "Έχεις κωδικό προσφοράς;",
  "promoDesc": "Βάλε έναν κωδικό προσφοράς για να εξαργυρώσεις πιστώσεις.",
  "promoPlaceholder": "π.χ. LAUNCH2026",
  "promoRedeem": "Εξαργύρωση",
  "promoSuccess": "Εξαργυρώθηκε — προστέθηκαν {n} πιστώσεις στον λογαριασμό σου.",
  "errPromoInvalid": "Αυτός ο κωδικός δεν είναι έγκυρος.",
  "errPromoExpired": "Αυτός ο κωδικός έχει λήξει.",
  "errPromoMaxed": "Αυτός ο κωδικός έφτασε το όριο χρήσεων.",
  "errPromoUsed": "Έχεις ήδη εξαργυρώσει αυτόν τον κωδικό.",
  "errPromoUserInit": "Ανανέωσε τη σελίδα και προσπάθησε ξανά.",
  "errPromoGeneric": "Δεν ήταν δυνατή η εξαργύρωση του κωδικού. Προσπάθησε ξανά.",
  "reportThisDesign": "Αναφορά αυτού του σχεδίου",
  "reportShort": "Αναφορά",
  "reportTitle": "Αναφορά σχεδίου",
  "reportDesc": "Τι πρόβλημα έχει αυτό το σχέδιο; Μόνο οι διαχειριστές βλέπουν την αναφορά σου.",
  "reportReason_spam": "Spam ή διαφήμιση",
  "reportReason_nsfw": "Σεξουαλικό ή ακατάλληλο περιεχόμενο",
  "reportReason_copyright": "Παραβίαση πνευματικών δικαιωμάτων",
  "reportReason_other": "Άλλο",
  "reportNotePlaceholder": "Πρόσθεσε λεπτομέρειες (προαιρετικό, έως 500 χαρακτήρες)",
  "reportSubmit": "Υποβολή αναφοράς",
  "reportSubmitting": "Υποβολή…",
  "reportSignInHint": "Συνδέσου για να υποβάλεις αναφορά.",
  "reportThanks": "Η αναφορά παραλήφθηκε",
  "reportThanksDesc": "Θα το ελέγξουμε και θα ενεργήσουμε αν χρειαστεί. Ευχαριστούμε για την αναφορά.",
  "errReportGeneric": "Δεν ήταν δυνατή η υποβολή της αναφοράς. Προσπάθησε ξανά σε λίγο.",
  "blockUser": "Αποκλεισμός χρήστη",
  "unblockUser": "Άρση αποκλεισμού",
  "blockShort": "Αποκλεισμός",
  "blockConfirm": "Αποκλεισμός του @{handle}; Δεν θα βλέπεις τα σχέδια ή τη δραστηριότητα αυτού του χρήστη, ούτε θα μπορεί να αλληλεπιδράσει με τα δικά σου.",
  "blockedUsersMenu": "Αποκλεισμένοι χρήστες",
  "blockedUsersTitle": "Αποκλεισμένοι χρήστες",
  "blockedUsersDesc": "Χρήστες που έχεις αποκλείσει. Τα σχέδιά τους είναι κρυμμένα από τη ροή σου.",
  "blockedUsersEmpty": "Δεν έχεις αποκλείσει κανέναν.",
  "profileBlocked": "Έχεις αποκλείσει αυτόν τον χρήστη.",
  "profileBlockedAction": "Ξεμπλόκαρε για να δεις ξανά τα σχέδιά του.",
  "errBlockGeneric": "Δεν ήταν δυνατή η ενημέρωση της κατάστασης. Δοκίμασε ξανά.",
  "errBlockedCustomCommand": "Το αίτημά σου περιέχει λέξεις που δεν επιτρέπονται.",
  "moderationAutoUnlisted": "Αυτό το σχέδιο αφαιρέθηκε αυτόματα από τη δημόσια ροή μετά από έλεγχο. Αν πιστεύεις ότι πρόκειται για λάθος, επικοινώνησε με τους διαχειριστές.",
  "promptLang": "Greek"
};
